// This file is AUTOGENERATED, do not edit it manually!!!

export const filters = {
    Activity_Text: 'Aktivität',
    ActivityActualCompletionDateCondition_Text: 'Tatsächliches Aktivität-Abschlussdatum',
    ActivityActualGreaterThanEstimated_Text: 'Unterschätzte Aktivitäten',
    ActivityCreationDateCondition_Text: 'Aktivitäts-Erstelldatum',
    ActivityCreator_Text: 'Aktivitätsersteller',
    ActivityCreatorCondition_Empty_Text: 'System',
    ActivityCreatorCondition_Text: 'Aktivitätsersteller',
    ActivityCustomFieldCondition_Text: 'Benutzerdefinierte Aktivitätsfelder',
    ActivityEndDateCondition_Text: 'Aktivitätsenddatum',
    ActivityHealthCondition_Text: 'Aktivitätsintegrität',
    ActivityHealthTypes: 'Aktivitätsintegrität',
    ActivityProcessCondition_Text: 'Aktivitätsfortschritt',
    ActivityProgress_Text: 'Aktivitätsfortschritt',
    ActivityStartDateCondition_Text: 'Aktivitätsstartdatum',
    ActivityStatusCondition_Text: 'Aktivitätsstatus',
    ActivityTypeCondition_Text: 'Aktivitätstyp:',
    ActivityTypes_Issue: 'Problem',
    ActivityTypes_Request: 'Anfrage',
    ActivityTypes_Task: 'Aufgabe',
    ActivityTypesCondition_Text: 'Aktivitätstypen',
    ActualCompletionDate_Text: 'Tatsächliches Abschlussdatum:',
    add_filters: 'Filter hinzufügen',
    AdvancedFilterTooltipContent_Text: 'Hier klicken, um alle möglichen Filteroptionen anzuzeigen',
    AdvancedFilterTooltipTitle_Text: 'Fortgeschrittene Filter:',
    AllActivities_Text: 'Aktivität',
    Apply_Text: 'Übernehmen',
    AssigneeCondition_Text: 'Aktivitätsbeauftragter',
    AssigneeOption_Text: 'Aktivitätsbeauftragte',
    AssigneeTeamCondition_Entity: 'Teams',
    AssigneeUserCondition_Empty_Text: 'Keine Beauftragten',
    AssigneeUserCondition_Entity: 'Aktivitätsbeauftragte',
    BoolCustomField_No_Text: 'Nein',
    BoolCustomField_NotSelected_Text: 'Nicht ausgewählt',
    BoolCustomField_Yes_Text: 'Ja',
    CategoriesCondition_Text: 'Kategorien',
    CategoryCondition_Empty_Text: 'Keine Kategorie',
    CategoryCondition_Entity: 'Kategorien',
    CategoryCondition_Text: 'Kategorie',
    Clear_All_Text: 'Alle löschen',
    CompletedStatus_Text: 'Abgeschlossen',
    ContainMore_Text: 'Keine weiteren Ergebnisse, bitte weiterschreiben …',
    CreationDate_Text: 'Erstelldatum',
    CustomerCondition_Empty_Text: 'Kein Kunde',
    CustomerCondition_Entity: 'Kunden',
    CustomerCondition_Text: 'Kunden',
    DraftCondition_Text: 'Entwürfe',
    DraftStatus_Text: 'Entwürfe',
    EndDate_Text: 'Enddatum',
    FilterByKeyword_Text: 'Filtern nach Schlagwort',
    FilterByPeriod_Text: 'Filtern nach Phase',
    FilterByTimeframe_Text: 'Filtern nach Zeitrahmen',
    FilterTabs_Tab1: 'Stati',
    FilterTabs_Tab2: 'Ressourcen & Beschränkungen',
    FilterTabs_Tab3: 'Gesundheit & Fortschritt',
    FilterTabs_Tab4: 'Projekte, Kunden & mehr',
    FilterTabs_Tab5: 'Benutzerdefinierte Felder',
    Followed: 'Ich folge',
    FollowedByMe_Text: 'Aktivitäten, denen ich folge',
    From_Text: 'von',
    HealthCondition_Text: 'Gesundheit',
    HealthItemType_Bad: 'Bedenklich',
    HealthItemType_Good: 'Gut',
    HealthItemType_Medium: 'Gefährdet',
    HealthItemType_NotCalculated: 'Nicht berechnet',
    HealthTooltip_Text: 'Integrität ist ein berechneter Index, der angibt, wie gut ein Projekt oder eine Aktivität voranschreitet',
    HealthTooltipLink_Text: 'Mehr dazu finden Sie in unserer Onlinehilfe',
    HoursCondition_Text: 'Zeit',
    InProgressStatus_Text: 'Meine Arbeit',
    InThePast: 'Vergangene',
    InvalidDate: 'Datum muss Format \'{0}\' aufweisen.',
    Issue_Text: 'Problem',
    KeepTyping_Text: 'Weiter eingeben ...',
    ListCustomFieldCondition_Empty_Text: 'Nicht ausgewählt',
    ManualRange: 'Festgelegte Datumsspanne …',
    Me: 'Ich',
    Menu_Dates: 'Daten',
    Milestone_Text: 'Meilenstein',
    MoneyCondition_Text: 'Geld',
    More_Text: 'Mehr',
    NextMonth: 'Nächster Monat',
    NextWeek: 'Nächste Woche',
    no_filters: 'Keine Filter zum Anzeigen',
    NoCategory: 'Keine Kategorie',
    NoMatch_Text: 'Leider wurde nichts gefunden',
    OnHoldStatus_Text: 'Aufgeschoben',
    PeopleCondition_Text: 'Menschen',
    PinTooltip_Text: 'Markierung',
    Portfolio_Status_Text: 'Portfoliostatus',
    PortfolioCondition_Empty_Text: 'Kein Portfolio',
    PortfolioCondition_Entity: 'Portfolios',
    PortfolioCondition_Text: 'Portfolios',
    PortfolioCreator_Text: 'Portfolioersteller',
    PortfolioCreatorCondition_Text: 'Portfolioersteller',
    PortfolioManager_Text: 'Portfoliomanager',
    PortfolioManagerCondition_Text: 'Portfoliomanager',
    PreviousMonth: 'Vorheriger Monat',
    PreviousWeek: 'Vorherige Woche',
    PreviousYear: 'Vorheriges Jahr',
    PriorityCondition_Text: 'Prioritäten',
    ProgressCondition_Entity: 'Fortschritt: ',
    ProgressCondition_Text: 'Fortschritt',
    Project_Text: 'Projekt',
    ProjectActualCompletionDateCondition_Text: 'Tatsächliches Abschlussdatum des Projektes',
    ProjectActualGreaterThanEstimated_Text: 'Unterschätzte Projekte',
    ProjectCondition_EmptyText: 'Kein Projekt ausgewählt',
    ProjectCondition_Entity: 'Projekte',
    ProjectCondition_Text: 'Projekte',
    ProjectCostExceedBudget_Text: 'Überbudgetierte Projekte',
    ProjectCreationDateCondition_Text: 'Projekterstelldatum',
    ProjectCreator_Text: 'Ersteller des Projektes',
    ProjectCreatorCondition_Text: 'Ersteller des Projektes',
    ProjectCustomFieldCondition_Text: 'Benutzerdefinierte Projektfelder',
    ProjectEndDateCondition_Text: 'Projektenddatum',
    ProjectHealthCondition_Text: 'Projektintegrität',
    ProjectHealthTypes: 'Projektintegrität',
    ProjectManager_Text: 'Projektmanager',
    ProjectManagerCondition_Text: 'Projektmanager',
    ProjectMemberCondition_Text: 'Projektmitglied',
    ProjectPriorityCondition_Text: 'Projektpriorität',
    ProjectPriorityCondition_Text_Template: 'Projekte mit %s Priorität',
    ProjectProcessCondition_Text: 'Projektfortschritt',
    ProjectProfit_Text: 'Projekte bei finanziellen Verlusten',
    ProjectProgress_Text: 'Projektfortschritt',
    ProjectsAndTasksList_Title: 'Projekte und Aufgaben',
    ProjectStartDateCondition_Text: 'Projektanfangsdatum',
    ProjectStatusCondition_Text: 'Projektstatus',
    QuickFilterWatermark: 'Filtern nach...',
    range_condition_text: 'Spanne',
    Request_Text: 'Anfrage',
    roles_condition_text: 'Rollen',
    RollBack_Text: 'Zurück zu vorherigen Filtern',
    SaveFilters_Title: 'Gespeicherte Filter',
    set_filters: 'Setzen Sie Filter mit dem',
    set_filters_part2: 'Ikon',
    skills_condition_text: 'Fähigkeiten',
    StartDate_Text: 'Startdatum',
    StatusesCountFormat: '1#{0} Status#{0} Stati',
    Task_Text: 'Aufgabe',
    TaskCondition_Entity: 'Aktivitäten',
    TaskCondition_Text: 'Aktivität',
    TaskCostExceedBudget_Text: 'Überbudgetierte Aktivitäten',
    TaskPriorityCondition_Entity: 'Aktivitätenpriorität',
    TaskPriorityCondition_Text: 'Aufgabenpriorität',
    TaskPriorityCondition_Text_Template: 'Aktivitäten mit %s Priorität',
    TasksAssignedToMilestone_Text: 'Meilenstein zugeordnete Aktivität',
    teams_condition_text: 'Teams',
    TemplateCondition_Text: 'Vorlagen',
    TemplateStatus_Text: 'Vorlagen',
    ThisMonth: 'Dieser Monat',
    ThisWeek: 'Diese Woche',
    ThisYear: 'Dieses Jahr',
    To_Text: 'bis',
    Today: 'Heute',
    TypesCondition_Text: 'Typen',
    UnpinTooltip_Text: 'Abpinnen',
    users_condition_text: 'Benutzer',
    Yesterday: 'Gestern',
};
